import appendToSearchParams from 'Common/Utils/appendToSearchParams';
import { getResource } from 'Common/Utils/apiHelpers';

const baseUrl = '/api/v2/appointments';

function fetchAppointmentsForTeamIds (year, grouping, types, teamIds, errorCallback) {
	const groupingEncoded = encodeURIComponent(grouping);
	const query = new URLSearchParams();
	appendToSearchParams(query, 'types', types);
	appendToSearchParams(query, 'teamIds', teamIds);
	query.append('invited', true);
	const url = `${baseUrl}/appointments/${year}/${groupingEncoded}?${query.toString()}`;

    return getResource(url, errorCallback);
}

function fetchAppointments (year, grouping, types, teams, errorCallback) {
	const groupingEncoded = encodeURIComponent(grouping);
	const query = new URLSearchParams();
	appendToSearchParams(query, 'types', types);
	appendToSearchParams(query, 'teams', teams);
	query.append('invited', true);
	const url = `${baseUrl}/appointments/${year}/${groupingEncoded}?${query.toString()}`;

    return getResource(url, errorCallback);
}

function fetchTemplates(grouping, year, errorCallback) {
    const groupingEncoded = encodeURIComponent(grouping);
    const query = {
        sortOrder: 'asc',
        sortField: 'name',
        page: 0,
        sizePerPage: 0,
        searchText: '',
        exportData: true
    };
    const url = `/api/v2/contracts/templates/${groupingEncoded}/true/${year}?pagination=${encodeURIComponent(JSON.stringify(query))}`;

    return getResource(url, errorCallback);
}

export { fetchAppointments, fetchTemplates, fetchAppointmentsForTeamIds };
